var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container fluid bottom-0"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-12"},[_vm._v("versión : "+_vm._s(_vm.applicationVersion))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }